import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, filter, take } from 'rxjs';
import { IDENTITY_PROVIDER, IdentityProvider } from '../../config/identity-provider';
import { AUTH_PROVIDER, AuthProvider } from '../providers/auth-provider';
import { MojoAuthorizationService } from './mojo-authorization.service';

@Injectable()
export class AuthService {
  private provider: AuthProvider = inject(AUTH_PROVIDER);
  private mojoAuthorizationService = inject(MojoAuthorizationService);
  private isUserAuthorized = new BehaviorSubject<boolean>(false);

  readonly identityProvider: IdentityProvider = IDENTITY_PROVIDER;

  isUserAuthorized$ = this.isUserAuthorized.asObservable();

  init() {
    this.provider.isAuthenticated$
      .pipe(
        filter((isAuthenticated) => isAuthenticated),
        take(1),
      )
      .subscribe(async () => {
        if (await this.mojoAuthorizationService.getBrowserIdCookie()) {
          this.isUserAuthorized.next(true);
        }
      });
  }

  public async logout() {
    if (this.identityProvider === 'auth0') {
      await this.mojoAuthorizationService.revokeAccessToken();
    }
    this.provider.logout().then(() => this.isUserAuthorized.next(false));
  }
}
